module.exports = __webpack_public_path__ + "img/mgw_epicwin.64fe6f49.png";